import storageService from '../../../Infrustructure/localStorageService'

let service = {
    read: function () {
        return JSON.parse(storageService.getItem("scanInfo")) || [];
    },
    write: function (info) {
        storageService.setItem("scanInfo", JSON.stringify(info));
    },
    clear: function () {
        storageService.removeItem("scanInfo");
    },
    groupBy(arr) {
        let boxGroups = [];
        arr.forEach((val, index) => {
            let boxNumber = val.boxNumber;
            let eancode = val.eanCode;
            let productLongCode = val.eanCodeInfo.ProductLongCode;
            let group = boxGroups.find(g => g.boxNumber === boxNumber && g.eanCode === eancode);
            if (group) {
                group.count++;
            } else {
                boxGroups.push({
                    boxNumber: boxNumber,
                    eanCode: eancode,
                    productLongCode: productLongCode,
                    count: 1,
                    perPackCount: Number(val.eanCodeInfo.AmountPerPackage),
                    get productCount() {
                        return this.count * this.perPackCount;
                    }
                });
            }
        })
        return boxGroups;
    }
}

export default service;

/*
groupBy return model
[
    {
        boxNumber:111,
        eanCode:222,
        productLongCode:'123123123
        count:2,
        perPackCount:2,
    },
    {
        boxNumber:111,
        eanCode:222,
        productLongCode:'123123123
        count:2,
        perPackCount:2,
    },
]
*/


// WEBPACK FOOTER //
// ./src/components/application/BoxScan/scanInfoService.js